import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class AddBONewDraftFormVersionInteractor {
  private applicantService: IApplicantService;

  constructor(applicantService) {
    this.applicantService = applicantService;
  }

  async execute(reportingPeriodApplicantId: number, formTypeId: number) {
    try {
      return this.applicantService.insertNewFormVersion(
        reportingPeriodApplicantId,
        formTypeId
      );
    } catch (error) {
      return error;
    }
  }
}
